<div class='app-header'>
  <div class='app-title'>
    <h1>{{windowTitle}}</h1>
  </div>
  <div class='user-header'>
    <kbm-user-management></kbm-user-management>
  </div>
</div>